import Big from 'big.js';

export function percentToRatio(percent: number) {
  return Big(percent).div(100).toNumber();
}
